import { useController, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";

/**
 * A TextField component integrated with react-hook-form.
 * It automatically handles form state, registration, and error display.
 * @param {string} name - The name of the field in the form.
 * @param {object} otherProps - Other props to pass to the MUI TextField.
 * @returns {JSX.Element}
 */
const FormTextField = ({ name, ...otherProps }) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  // ensure MUI TextField always receives a string value to avoid null warnings
  const { value, ...fieldProps } = field;

  return (
    <TextField
      {...fieldProps}
      // coalesce null/undefined to empty string for rendering
      value={value ?? ""}
      {...otherProps}
      error={!!error}
      helperText={error?.message || otherProps.helperText}
    />
  );
};

export default FormTextField;
